import { ForbiddenErrorMessage } from '@/common/components/ForbiddenErrorMessage'
import { UnknownErrorMessage } from '@/common/components/UnknownErrorMessage'
import { ReactNode } from 'react'
import { NotFoundErrorMessage } from '../NotFoundErrorMessage'

interface ErrorMessageWrapperProps {
  children: ReactNode
  className?: string
  refetchFunction?: VoidFunction
  statusCode?: number
  notFoundFallback?: string
  notFoundButtonText?: string
  notFoundHideButton?: boolean
}

export const ErrorMessageWrapper = ({
  children,
  className,
  refetchFunction = () => undefined,
  statusCode,
  notFoundFallback,
  notFoundButtonText,
  notFoundHideButton,
}: ErrorMessageWrapperProps) => {
  if (statusCode === 403) return <ForbiddenErrorMessage className={className} />

  if (statusCode === undefined || (statusCode >= 200 && statusCode < 300)) return children

  if (statusCode === 404)
    return (
      <NotFoundErrorMessage
        className={className}
        fallback={notFoundFallback}
        buttonText={notFoundButtonText}
        hideButton={notFoundHideButton}
      />
    )

  return <UnknownErrorMessage refetchFunction={refetchFunction} className={className} />
}
